<template>
  <router-link to="/">   
    <img :src="ImageEndpoint + CompanyLogo" class="img-fluid for-light1" v-if="CompanyLogo" style="max-height:30px;max-width:85% ">
    <img src="@/assets/images/logo.png" class="img-fluid for-light1" v-if="!CompanyLogo" style="max-width:85%">
  </router-link>
</template>
<script>

  export default {
    name: 'Logo',    
	data(){
		return {			
			CompanyName:"",
			CompanyLogo:"",
			ImageEndpoint: Endpoints.Helper.Image+ '/',
		}
	},
	mounted(){		
		var Company = JSON.parse(localStorage.getItem('Company'))
		if(Company && Company.logo){	
			this.CompanyLogo = Company.logo
			this.CompanyName = Company.name
		}
	},
  };
</script>
